<template>
  <div class="about">
    <!-- START - BANNER -->
    <Banner image="noche-1" />
    <!-- END - BANNER -->
    <v-container>
      <!-- START - BUSCADOR -->
      <v-card-title>
        Gepres Blogs
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <!-- END - BUSCADOR -->
      <!-- START - TABLA -->
      <v-data-table
        :headers="headers"
        :items="blogs"
        :search="search"
        class="elevation-1"
        >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>blogs</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-btn text to="/dash">Dash</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="modalCreate()" dark class="mb-2">Nuevo Blog</v-btn>
            <v-dialog v-model="dialogEdit" max-width="600px">
              <v-card>
                <v-card-title class="d-flex justify-space-between">
                  <span class="headline">Editar Blog</span>
                  <v-col class="content-show">
                    <v-switch
                      hide-details
                      class="content-show__switch"
                      v-model="editedItem.show"
                      :label="`${editedItem.show ? 'mostrando' : 'ocultado'}`"
                    ></v-switch>
                  </v-col>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" >
                        <v-text-field v-model="editedItem._id" label="Id" disabled></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field label="fecha" v-model="editedItem.date" disabled></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.title" label="Titulo" :rules="titleRules" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.author" label="Autor" :rules="authorRules" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          item-text="name"
                          item-value="_id"
                          :items="categories"
                          label="Categoria"
                          v-model="editedItem.category"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field :messages="['Campo opcional']" v-model="editedItem.link" label="Enlace"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">  
                        <v-textarea v-model="editedItem.description" name="input-7-4" label="Descripción" :rules="descriptionRules" :counter="200" required>
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">  
                        <div class="caption">Contenido</div>
                        <ckeditor :editor="editor" v-model="editedItem.content" :config="editorConfig"></ckeditor>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="saveEdit">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.views="{ item }">
          <v-chip v-if="item.show === true" text-color="white" color="green" class="ma-2">
            <v-avatar left>
              <i class="fas fa-eye"></i>
            </v-avatar>
            {{item.views}}
          </v-chip>
          <v-chip v-if="item.show === false" class="ma-2">
            <v-avatar left>
              <i class="fas fa-eye"></i>
            </v-avatar>
            {{item.views}}
          </v-chip>
        </template>
         <template v-slot:item.url="{ item }">
          <a :href="`${LocationWeb}/blog/${item._id}`" @click="obtenerDatos" target="_blank"><i class="fas fa-link"></i></a>
        </template>
        <template v-slot:item.title="{ item }">
          {{ item.title.substr(0,10) }}
        </template>
        <template v-slot:item.date="{ item }">
          {{item.date | momentDateTable}}
        </template>
        <template v-slot:item.link="{ item }">
          <v-chip class="" text-color="white" v-if="item.link !== ''" color="green">con enlace</v-chip>
          <v-chip class="" text-color="white" v-else color="red">sin enlace</v-chip>
        </template>
        <template v-slot:item.description="{ item }">
          {{ item.description.substr(0,8) }}
        </template>
        <template v-slot:item.imageURL="{ item }">
          <img :src="item.imageURL" width="50" height="50" style="border-radius:50%;" />
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
          mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="modalDelete(item)"
          >
          mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <!-- END - TABLA -->
      <!-- START - DIALOG DELETE -->
      <v-dialog v-model="dialogDelete" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Desea eliminar a {{this.editedItem.title}} ?</v-card-title>
          <v-card-text>No podrá recuperarlo.</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="green darken-1" text @click="dialogDelete = false">No</v-btn>
            <v-btn color="green darken-1" text @click="deleteItem()">Si</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END - DIALOG DELETE -->
      <!-- START - DIALOG CREATE -->
      <v-dialog v-model="dialogCreate" persistent max-width="600">
        <v-card>
          <v-card-title class="card-title d-flex justify-space-between">
            <span class="headline">Nuevo Blog</span>
            <v-col class="content-show">
              <v-switch
                hide-details
                class="content-show__switch"
                v-model="post.show"
                :label="`${post.show ? 'mostrando' : 'ocultado'}`"
              ></v-switch>
            </v-col>
          </v-card-title>
              <v-card-text>
                <v-form  v-model="valid" ref="form" @submit.prevent="save" enctype="multipart/form-data">
                  <v-row>
                    <v-col cols="12" sm="12" md="8">
                    <v-text-field v-model="post.title" :rules="titleRules" label="Titulo" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field v-model="post.author" :rules="authorRules" label="Autor" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <div class="caption">Agregar imagen</div>
                    <div class="content-file">
                      <input
                        type="file"
                        accept="image/*"
                        ref="file"
                        @change="onSelect"
                        id="file-7" class="inputfile inputfile-6"
                      >
                      <label for="file-7" class="content-file__label"><span>{{seletedFileName}}</span> <strong><svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/></svg> Selecionar archivo&hellip;</strong></label>
                    </div>
                    <p class="caption text-right">Subir archivo de menos de 2MB</p>
                    <v-progress-linear
                      color="light-blue"
                      height="15"
                      :value="uploadValue"
                      max="100"
                      striped
                    >
                      <strong>{{ Math.ceil(uploadValue) }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      item-text="name"
                      item-value="_id"
                      :items="categories"
                      label="Categoria"
                      v-model="post.category"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field :messages="['Campo opcional']" v-model="post.link" label="Link"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea v-model="post.description" name="input-7-4" label="Descripción" :rules="descriptionRules" :counter="200">
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <div class="caption">Contenido</div>
                    <ckeditor :editor="editor" v-model="post.content" :config="editorConfig"></ckeditor>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <alert-error :text="this.error" v-show="this.error !== ''" />
                  </v-col>
                  <v-card-actions style="width:100%;">
                    <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click.stop="dialogCreate = false" >Cancelar</v-btn>
                      <v-btn color="blue darken-1" :disabled="!valid" type="submit" text >Guardar</v-btn>
                  </v-card-actions>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
      </v-dialog>
      <!-- END - DIALOG CREATE -->
    </v-container>
  </div>
</template>

<script>
  import Banner from '@/components/BannerBlog';
  import AlertError from '@/components/AlertError'
  const moment = require('moment');
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {mapState} from 'vuex';
  export default {
    name:'about',
    components:{Banner,AlertError},
    created(){
      this.obtenerDatos(),
      this.$store.dispatch('cargarCategorias')
      if(localStorage.getItem('token') === null){
        this.$router.push('/login')
      }
    },
    data(){
      return {
        valid:true,
        blogs:[],
        dialogCreate:false,
        dialogEdit: false,
        dialogDelete:false,
        seletedFileName:'',
        uploadValue:0,
        search: '',
        error:'',
        headers: [
          {
            text: 'Vistas',
            align: 'center',
            value: 'views',
          },
          { text: 'URL', value: 'url', align: 'center', sortable: false },
          { text: 'Titulo', value: 'title', align: 'center' },
          { text: 'Autor', value: 'author', align: 'center' },
          { text: 'Categoría', value: 'category.name', align: 'center' },
          { text: 'Fecha', value: 'date', align: 'center' },
          { text: 'Enlace', value: 'link', align: 'center', sortable: false },
          { text: 'Descripción', value: 'description', align: 'center', sortable: false },
          { text: 'Imagen', value: 'imageURL',align: 'center', sortable: false },
          { text: 'Actions', value: 'action',align: 'center', sortable: false },
        ],
        post:{
          title: '',
          author: 'Genaro Pretill',
          description: '',
          file:'',
          link:'',
          content:'',
          category:'',
          show:true
        },
        editedItem: {
          title: '',
          author: '',
          description: '',
          link:'',
          date:'',
          content:'',
          category:'',
          error:'',
          show:''
        },
        defaultItem: {
          title: '',
          author: '',
          description: '',
          date:'',
          link:'',
          content:'',
          category:'',
          show:true
        },
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [ 'heading', '|','bold', 'italic', '|', 'link','bulletedList', 'numberedList', 'insertTable' ]
        },
        titleRules: [
          v => !!v || 'Titulo es requerido',
        ],
        authorRules: [
          v => !!v || 'Autor es requerido',
        ],
        descriptionRules: [
          v => !!v || 'Descripción es requerido',
        ],
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    methods:{
      onSelect(){
        const file = this.$refs.file.files[0]
        this.post.file = file
        this.seletedFileName = file.name
        
      },
      async obtenerDatos(){
        await this.axios.get(`${this.$store.state.baseURL}/api/blogs`,{
          headers: { token: localStorage.getItem('token')}
          })
          .then(res => {
            const resultado = res.data 
            this.blogs = resultado
          })
      },
      modalCreate(){
        this.dialogCreate = true;
        this.post.content = " "
      },
      editItem (item) {
         moment.locale('es');
        this.editedIndex = this.blogs.indexOf(item)
        this.editedItem = Object.assign({}, item)
        const momentDate = moment(this.editedItem.date).format('MMMM Do YYYY, h:mm:ss a')
        this.editedItem.date = momentDate
        this.error =''
        this.dialogEdit = true
      },
      modalDelete(item){
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItem () {
        this.axios.delete(`${this.$store.state.baseURL}/api/blogs/`+this.editedItem._id,{
          headers: { token: localStorage.getItem('token')}
          })
          .then(res => {
            this.obtenerDatos()
            // console.log('blog Eliminado');
            this.dialogDelete = false
          })
      },
      close () {
        this.dialogEdit = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
        }, 300)
      },
      closeCreate () {
        this.dialogCreate = false
      },
      async save (){
        const formData = new FormData()
        formData.append('file',this.post.file)
        formData.append('title',this.post.title)
        formData.append('author',this.post.author)
        formData.append('link',this.post.link)
        formData.append('description',this.post.description)
        formData.append('content',this.post.content)
        formData.append('category',this.post.category)
        formData.append('show',this.post.show)
        formData.append('date',Date.now())
        if(this.post.title !== '' && this.post.author !== '' && this.post.description !== '' && this.seletedFileName !== '' && this.post.content !== '' && this.post.category !== ''){
           await this.axios.post(`${this.$store.state.baseURL}/api/blogs`,formData,{ 
              headers: { token: localStorage.getItem('token')},
              onUploadProgress: function( progressEvent ) {
                this.uploadValue = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
              }.bind(this)
            })
              .then(res => {
                this.obtenerDatos()
                // console.log('blog agregado')
                this.post.title = '',
                this.post.author = 'Genaro Pretill',
                this.post.link = '',
                this.post.description = '',
                this.uploadValue = 0,
                this.seletedFileName ='',
                this.post.content ='',
                this.post.category ='',
                this.error = '',
                this.post.show = true
              })
              .catch(error => {
                console.log(error);
              });
            this.closeCreate()
        }else{
          this.error ="Complete todo los campos"
          setTimeout(() => {
            this.error = ''
          }, 3000);
        }
       
      },
      async saveEdit () {
        if(this.editedItem.title !== '' && this.editedItem.author !== '' && this.editedItem.description !== '' && this.editedItem.content !== ''){
          await this.axios.put(`${this.$store.state.baseURL}/api/blogs/`+ this.editedItem._id, {
          title:this.editedItem.title ,
          author: this.editedItem.author,
          link:this.editedItem.link,
          description:this.editedItem.description,
          content:this.editedItem.content,
          category:this.editedItem.category,
          show:this.editedItem.show
          },{
          headers: { token: localStorage.getItem('token')}
          })
            .then(res => {
              this.obtenerDatos()
              // console.log('blog actualzado');
            })
            .catch(function (error) {
              console.log(error);
            });
          this.close()
        }else{
          this.error ="Complete todo los campos"
          alert('Complete todo los campos')
          setTimeout(() => {
            this.error = ''
          }, 3000);
        }
      }
    },
    computed:{
      LocationWeb(){
        return window.location.origin
      },
       ...mapState(['categories'])
    },
    filters:{
      momentDate(value) {
        moment.locale('es');
        return moment(value).fromNow()
      },
      momentDateTable(value) {
        moment.locale('es');
        return moment(value).format('ll')
      }
    }
  }
</script>

<style lang="scss" scoped>
.inputfile{
  width: 100%;
  display:none;
}
.content-file__label{
  width: 100%;
  border-radius: .3rem;
  border: 1px solid #424242;
  & strong{
    float:right;
    @media screen and (max-width:960px) {
      float:none;
    }
  }
  margin-top: 1.5rem;
}
.inputfile + label {
    max-width: 100%;
    font-size: 1.25rem;
    /* 20px */
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0.625rem 1.25rem;
    /* 10px 20px */
}
.inputfile:focus + label,
.inputfile.has-focus + label {
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
    width: 1em;
    height: 1em;
    vertical-align: middle;
    fill: currentColor;
    margin-top: -0.25em;
    /* 4px */
    margin-right: 0.25em;
    /* 4px */
}
/* style 6 */
.inputfile-6 + label {
    color: #42A5F5;
}
.inputfile-6 + label {
    // border: 1px solid #1B5E20;
    background-color: #f1e5e6;
    padding: 0;
}
.inputfile-6:focus + label,
.inputfile-6.has-focus + label,
.inputfile-6 + label:hover {
    border-color: #1A237E;
}
.inputfile-6 + label span,
.inputfile-6 + label strong {
    padding: 0.625rem 1.25rem;
    /* 10px 20px */
}
.inputfile-6 + label span {
    width: 200px;
    min-height: 2em;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: top;
}
.inputfile-6 + label strong {
    height: 100%;
    color:#1565C0;
    background-color: #fff;
    display: inline-block;
}
.inputfile-6:focus + label strong,
.inputfile-6.has-focus + label strong,
.inputfile-6 + label:hover strong {
    background-color: #1A237E;
}
@media screen and (max-width: 50em) {
	.inputfile-6 + label strong {
		display: block;
	}
}
.content-show{
  display: flex;
  width: 50%;
  justify-content: flex-end;
  padding: 0;
  &__switch{
    margin: 0;
    padding: 0;
  }
}
</style>